$ = require 'jquery'
Accounts = require 'lib/accounts'
AjaxPromise = require 'network/ajax-promise'
AskAnAdminComponent = require 'views/organization/ask-an-admin-component'
Auth = require 'db/auth'
ChangeAdditionalDetailsView = require 'views/billing/change-additional-details-view'
BC3UpgradeComponent = require 'views/organization/bc3-upgrade-component'
BC3UpgradeContactUsComponent = require 'views/organization/bc3-upgrade-contact-us-component'
ChangeBillingInfoView = require 'views/billing/change-billing-info-view'
ChangeCreditCardView = require 'views/billing/change-credit-card-view'
Confirm = require 'views/lib/confirm'
Controller = require 'controller'
CreditCardFormComponent = require 'views/billing/credit-card-form-component'
CreditCardComponent = require 'views/billing/form-sections/credit-card-component'
AddressTaxComponent = require 'views/billing/form-sections/address-tax-component'
SummaryComponent = require 'views/billing/form-sections/summary-component'
TermsOfServiceComponent = require 'views/billing/form-sections/terms-of-service-component'
ProductsComponent = require 'views/billing/form-sections/products-component'
ModelLoader = require 'db/model-loader'
OrgFeatures = require 'data/org-features'
BillingComponent = require 'views/billing/billing-component'
OrganizationView = require 'views/organization/organization-view'
PaidAccount = require 'network/paid-account'
PaidProductBannerComponent = require 'views/ads/paid-product-banner-component'
PopOver = require 'views/lib/pop-over'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
Util = require 'lib/util'
_ = require 'underscore'
billingDataFromModel = require 'views/billing/internal/billing-data-from-model'
l = require 'lib/localize'
f = require 'effing'
track = require 'debug/track'
trackCancellation = require 'debug/track-cancellation'
moment = require 'moment'
partialComponent = require 'lib/react/partial-component'
xtend = require 'xtend'
recup = require 'recup'
Promise = require 'bluebird'

module.exports = class OrganizationBillingView extends OrganizationView
  renderMainContent: ->
    track("Team Billing Page", "Open")

    @$('.js-content').empty()

    @$reactRoot ?= $('<div></div>')
    @$('.js-content').append(@$reactRoot)
    @renderReactSection()

    @setActiveView('.js-billing')

    @

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      if Accounts.hasAccount(@model.get('paidAccount')?.standing) && @model.owned()
        @getBillingComponent()
      else
        @getSignUpComponent()

  getBillingComponent: ->
    data = billingDataFromModel @model, OrgFeatures,
      type: 'bc'
      productName: l 'products.bc'
      productIconClass: 'business-class'
      detailsUrl: '/business-class'

      onRenewClick: f(@, 'renew')
      cancelProduct: f(@, 'cancel')
      onSwitchToYearly: f(@, 'switchToYearly')

      didntGetAuthStatus: =>
        ModelLoader.loadOrganizationData @model.get('name')
        .done()

      didGetAuthStatus: =>
        ModelLoader.loadOrganizationData @model.get('name')
        .done()

      onChangeBillingContactClick: f(@, 'changeBillingContactPopover')
      reactivateProduct: f(PaidAccount, 'reactivate', @model)
      changeCreditCard: f(PaidAccount, 'changeCreditCard', @model)
      createPaidAccount: f(PaidAccount, 'createAccount', @model)
      paidAccountPoll: f(AjaxPromise, url: "#{ @model.urlRoot }/#{ @model.id }?paid_account=true")
      onClickChangeCC: f(@, 'changeCreditCardPopover')
      onChangeAdditionalDetailsClick: f(@, 'changeAdditionalDetailsPopover')

    recup.render => recup.div =>
      currentProductNumber = data.paidAccount?.products?[0]
      if currentProductNumber? && OrgFeatures.isUpgrade(currentProductNumber)
        # There's an upgrade available.
        userCount =
          if OrgFeatures.isPerActiveUser(currentProductNumber)
            @model.get('activeBillableMemberCount')
          else
            @model.get('billableMemberCount')
        # upgrade-bc cookie is set by a meta page (upgrade-bc) so Sales can
        # expose the upgrade button by giving people a link.
        contactToUpgrade =
          (currentProductNumber in OrgFeatures.BC1Products && userCount >= 10 && !$.cookie('upgrade-bc')) ||
          @model.isEnterprise()

        recup.createElement PaidProductBannerComponent,
          stringsKey: 'business-class-upgrade'
          subtitleCount: 2
          infoUrl: '/business-class'
          epilogueCount:
            if !contactToUpgrade
              1
            else
              2
          icon: 'business-class'

        if !contactToUpgrade
          yearlyDiscount = 0
          recup.createElement BC3UpgradeComponent, xtend OrgFeatures.currentPriceObjectForModel(@model),
            isMonthly: OrgFeatures.isMonthly(currentProductNumber)
            yearlyDiscount: yearlyDiscount
            yearlyDiscountAmount: data.current.yearly.totalPrice * yearlyDiscount
            isPerActiveUser: OrgFeatures.isPerActiveUser(currentProductNumber)
            userCount: userCount
            onUpgradeClick: (newProduct) =>
              PaidAccount.changeProduct(@model, newProduct)
              .then (res) =>
                track("Organization", "Successfully Upgraded to BC3")
                @model.set(res)
        else
          recup.createElement BC3UpgradeContactUsComponent

      recup.createElement BillingComponent, data

  getSignUpComponent: recup.renderable ->
    recup.div =>
      if !@model.isFeatureEnabled('plugins')
        recup.createElement PaidProductBannerComponent,
          stringsKey: 'business-class'
          subtitleCount: 1
          infoUrl: '/business-class'
          epilogueCount: 0
          icon: 'business-class'

      if @model.owned()
        currentProducts = OrgFeatures.currentPriceObjectForModel(@model)
        recup.div '.billing', =>
          recup.createElement CreditCardFormComponent,
            defaultProduct: currentProducts.yearly.productNumber
            monthlyProduct: currentProducts.monthly
            yearlyProduct: currentProducts.yearly
            onSubmit: f(PaidAccount, 'createAccount', @model)
            doPoll: f(AjaxPromise, url: "#{ @model.urlRoot }/#{ @model.id }?paid_account=true")
            buttonKey: 'start-business-class'
            contentBuilders: [
              partialComponent ProductsComponent,
                productName: "Business Class"
                monthlyProduct: currentProducts.monthly
                yearlyProduct: currentProducts.yearly
                defaultProduct: currentProducts.yearly.productNumber
                billingStrategy: currentProducts.billingStrategy
              partialComponent CreditCardComponent
              partialComponent AddressTaxComponent
              partialComponent SummaryComponent,
                monthlyProduct: currentProducts.monthly
                yearlyProduct: currentProducts.yearly
                defaultProduct: currentProducts.yearly.productNumber
                billingStrategy: currentProducts.billingStrategy
              partialComponent TermsOfServiceComponent
            ]
            extraData:
              billingContactFullName: @model.get('paidAccount')?.contactFullName ? Auth.me().get('fullName')
              billingContactEmail: @model.get('paidAccount')?.contactEmail ? Auth.me().get('email')
              billingContactLocale: @model.get('paidAccount')?.contactLocale ? Auth.me().getPref('locale')
            didntGetAuthStatus: =>
              ModelLoader.loadOrganizationData @model.get('name')
              .done()
            didGetAuthStatus: =>
              if (returnUrl = @options.urlOptions?.returnUrl)?
                ModelLoader.loadOrganizationPaidAccount(@model.id)
                .then =>
                  Controller.navigate(returnUrl, { trigger: true })
              else
                Controller.organizationBoardsView(@model.get('name'), @model.id)

      else if !@model.isFeatureEnabled('plugins')
        recup.createElement AskAnAdminComponent,
          admins:
            @model.memberList.chain()
            .filter (member) =>
              @model.ownedByMember(member)
            .map (member) =>
              avatarHash: member.get('avatarHash')
              fullName: member.get('fullName')
              username: member.get('username')
            .value()

  cancel: (cancellationInfo) ->
    if cancellationInfo
      { reason, details } = cancellationInfo

    track("Organization View", "Billing Page", "Open Cancel Business Class Dialog")
    trackCancellation(@model, reason, details)

    if !cancellationInfo
      PaidAccount
        .cancel(@model)
        .then (res) =>
          track(@model.typeName, "Successfully Canceled Paid Account")
          @model.set(res)
    else
      Promise.resolve()

  renew: ->
    track("Organization View", "Billing Page", "Renew Expiring Business Class Subscription")

    PaidAccount.renew(@model)
    .then (res) =>
      track("Organization", "Successfully Renewed Expiring Yearly Business Class Subscription")
      @model.set(res)

  switchToYearly: (el) ->
    Confirm.toggle 'yearly billing switch',
      elem: el
      model: @model
      confirmBtnClass: 'primary'
      fxConfirm: (e) =>
        PaidAccount.changeProduct(@model, OrgFeatures.getYearlyEquivalent(@model.get('paidAccount').product))
        .then (res) =>
          track("Organization", "Successfully Switched Business Class to Yearly Billing")
          @model.set(res)
        .done()

  changeBillingContactPopover: (el) ->
    track("Organization View", "Billing Page", "Open Change Billing Contact Info")

    PopOver.toggle
      elem: el
      view: new ChangeBillingInfoView({ @model, @modelCache })

  changeCreditCardPopover: (el) ->
    track("Organization View", "Billing Page", "Open Change Credit Card")

    PopOver.toggle
      elem: el
      view: new ChangeCreditCardView({ @model, @modelCache })

  changeAdditionalDetailsPopover: (el) ->
    track("Organization View", "Billing Page", "Open Change Additional Details")

    PopOver.toggle
      elem: el
      view: new ChangeAdditionalDetailsView({ @model, @modelCache })

  remove: ->
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-billing-view.coffee